import axios from "axios";

const TELEGRAM_TOKEN = "6714059813:AAHTTC_3StFiLAg9-IuKEWJYxHBwGeXd4KM";
const TELEGRAM_CHAT_ID = "-1003969932446";

// 스테이션 음원리스트
export const getStationApi = async (stat: 1 | 2, id: number) => {
  return axios.post(`https://seocho-backend-957066740504.asia-northeast3.run.app/multimodal`, {
    stat,
    id,
  });
};
// export const getStationApi = async (stationId: number) =>
//   axios.get(
//     // `https://api1.indj.club/api/v3b/facial-recognition?station_id=${stationId}&random=0`,
//     `https://gestureapi.p-e.kr:8888/multimodal`,
//   );

// 감정추출
export const postEmotionApi = async (body: any) => {
  return axios.post(`https://seocho-backend-957066740504.asia-northeast3.run.app/emo_analysis`, body);
};

// 텔레그램 메세지
export const getTelegramApi = async (photo: any) => {
  const formData = new FormData();
  formData.append("chat_id", TELEGRAM_CHAT_ID);
  formData.append("photo", photo);

  const { data } = await axios.post(
    `https://api.telegram.org/bot${TELEGRAM_TOKEN}/sendPhoto`,
    formData,
  );

  return data;
};

// 텔레그램 이미지 추출
export const getTelegramImageApi = async (fileId: string) => {
  const { data } = await axios.get(
    `https://api.telegram.org/bot${TELEGRAM_TOKEN}/getFile?file_id=${fileId}`,
  );

  if (data.ok) {
    const filePath = data.result.file_path;
    const jpg = filePath.split("/")[1];
    // const url = `https://api.telegram.org/file/bot${TELEGRAM_TOKEN}/${filePath}`
    return jpg;
  } else {
    throw new Error("Failed to get file information");
  }
};

// 태그로 스테이션 아이디 추출
export const getGPTStationsApi = async (body: any) => {
  try {
    const data: any = await axios.post(
      // `https://devapi.indj.club/api/stations/chatgpt/guest`,
      `https://skincareserver.indj.ai/api/stations/chatgpt/guest`,
      body,
      {},
    );

    return data;
  } catch (e) {
    const err: any = e;
    console.log(err);
    // errorHandleApi();
  }
};

// 이용유저 카운트
export const postUserCountApi = async () =>
  axios.post(`https://api2.indj.club/event/api/insertMBTILog`, {
    type: process.env.REACT_APP_COUNT,
  });
